export default "__VITE_ASSET__K4JR5MbP__$_?url__"